import { useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { getCurrentDateWithDay } from "@/helpers/format-date";
import { findDailyForecastById } from "@/helpers/daily-forecast-helpers";

import Skeleton from "@/components/skeletons/Skeleton";
import CardList from "@/components/forecast/card-list/CardList";

import "./style.scss";

export const App = () => {
	const {
		dayliesData,
		isLoading,
		error,
		date: selectedDate,
		cityId,
	} = useSelect((select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
		const store = select(WEATHER_STORE);

		return {
			...store.getDailyForecast(),
			date: store.getDateSelectedCityState(),
			cityId: store.getCityLocationState().cityId,
		};
	});

	const filtredDataByID = findDailyForecastById(cityId, dayliesData);

	const formattedData = filtredDataByID
		.map((item) => {
			const { date, day } = getCurrentDateWithDay(item.date);

			return {
				...item,
				dayWeek: date,
				day,
			};
		})
		.slice(0, 10);

	return (
		<div className="weather-ten-days-card">
			{isLoading ? (
				<div className="card-list">
					<Skeleton
						className="card-content"
						length={8}
						height={100}
						width={150}
						borderRadius={24}
					/>
				</div>
			) : error ? (
				<></>
			) : (
				<CardList
					data={formattedData}
					selectedDate={selectedDate}
					type="weather"
				/>
			)}
		</div>
	);
};

export default App;
